import { create } from 'zustand';

export interface IAdminResponse {
  admin: {
    config: {
      verification: {
        totpSecret: string;
      };
    };
    digestFreqency: number | null;
    email: string;
    firstName: string;
    id: string;
    lastName: string;
    movaticAccess: number;
    partner: any | null;
    phone: string | null;
    sendDigest: boolean | null;
    jwt_token: string;
    token: string;
  } | null;
  adminDate: Date | null;
}

export interface IAdminStore {
  admin: IAdminResponse;
  setAdmin: (admin: IAdminResponse) => void;
}

export const useAdminStore = create<IAdminStore>((set, get) => ({
  admin: {
    admin: {
      config: {
        verification: {
          totpSecret: '',
        },
      },
      digestFreqency: null,
      email: '',
      firstName: '',
      id: '',
      lastName: '',
      movaticAccess: 0,
      partner: null,
      phone: null,
      sendDigest: null,
      jwt_token: '',
      token: '',
    },
    adminDate: null,
  },
  setAdmin: (admin: IAdminResponse) => {
    return set({ admin });
  },
}));
